module.exports = __webpack_public_path__ + "static/media/bb.6ad3acfa.svg";